import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";
// React DateTime
import Datetime from "react-datetime";
import moment from "moment";
// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import {
  deleteData,
  getAlert,
  insertData,
  updateData,
} from "../../../../utils/SamuiUtils";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataEmpPosition,
  dataEmpDept,
}) => {
  const [initialFormData, setInitialFormData] = useState({});
  
  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Prevent shortcuts when typing in input fields
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.tagName === 'SELECT') {
        return;
      }
      
      // ESC key - Cancel/Back
      if (event.key === 'Escape') {
        event.preventDefault();
        if (window.confirm('ต้องการยกเลิกการทำงานหรือไม่?')) {
          window.location.href = "/tbsetdept";
        }
      }
      
      // F10 key - Save
      if (event.key === 'F10') {
        event.preventDefault();
        if (mode === 'I') return;
        if (mode === 'U') {
          confirmAndUpdate();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        Comp_Id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        Dept_Id: 0,
        Dept_Name: "",
        Dept_Status: "Y",
        Comp_Id: localStorage.getItem("company") || 0,
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        Dept_Id: selectedData.Dept_Id,
        Dept_Name: selectedData.Dept_Name,
        Dept_Status: selectedData.Dept_Status,
        Comp_Id: selectedData.Comp_Id || localStorage.getItem("company") || 0,
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInsertEmployee = async () => {
    try {
      const { Dept_Id, ...dataToInsert } = formData; // กรอง Dept_Id ออกก่อน
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      const res = await insertData("Tb_Set_Dept", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error inserting employee:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const formatValues = (data) => {
    const { Dept_Id, ...rest } = data;
    return rest;
  };

  const handleUpdateEmployee = async () => {
    try {
      const where = { Dept_Id: formData.Dept_Id };
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_Dept", values, where);
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize();
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData(
            "Tb_Set_Dept",
            `WHERE Dept_Id = ${selectedData.Dept_Id}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      })
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const confirmAndSubmit = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการบันทึกข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await handleSubmit();
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const confirmAndUpdate = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการแก้ไขข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await handleUpdateEmployee();
          await callInitialize();
          window.location.href = "/dept";
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    try {
      if (mode === "I") {
        await handleInsertEmployee();
      } else if (mode === "U") {
        await handleUpdateEmployee();
      }
      await callInitialize();
      setFormData({
        Dept_Id: 0,
        Dept_Name: "",
        Dept_Status: "Y",
        Comp_Id: localStorage.getItem("company") || 0,
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/Dept" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="mb-3 border-bottom pb-2">ข้อมูลแผนก</h5>
            <div className="row g-3">
              <div className="col-6">
                <label>ชื่อแผนก</label>
                <input type="text" className="form-control" name="Dept_Name" value={formData.Dept_Name || ""} onChange={handleChange} />
              </div>

              <div className="col-6">
                <label>สถานะ</label>
                <select className="form-select" name="Dept_Status" value={formData.Dept_Status || "Y"} onChange={handleChange}>
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
            </div>

            <div className="row mt-4">
              {mode !== "I" ? (
                <div className="d-flex justify-content-between align-items-center">
                  <button onClick={handleDelete} type="button" className="btn btn-danger btn-lg">ลบ</button>
                  <div className="d-flex gap-2">
                    <button onClick={() => (window.location.href = "/dept")} type="button" className="btn btn-dark btn-lg">ยกเลิก</button>
                    <button onClick={confirmAndUpdate} type="button" className="btn btn-warning text-white btn-lg">บันทึก</button>
                  </div>
                </div>
              ) : (
                <div className="d-flex">
                  <FormAction onSubmit={handleSubmit} onUpdate={handleSubmit} onDelete={handleDelete} mode={mode} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
